// Import automatique de toutes les locales disponibles
function importAllLocales() {
  const locales = {};

  // Auto-détection des locales basée sur require.context
  const localeContext = require.context('./', true, /^\.\/[^/]+\/index\.js$/);

  localeContext.keys().forEach((item) => {
    const localeName = item.replace('./', '').replace('/index.js', '');
    const localeModule = localeContext(item);
    locales[localeName] = localeModule.default || localeModule;
  });

  return locales;
}

export default importAllLocales();
